import { FooterContainer } from "../atoms/containers/ContentContainers";
import { FooterContent } from "../molecules/footer_content/FooterContent";

export function Footer() {
	return (
		<FooterContainer>
			<FooterContent />
		</FooterContainer>
	);
}
